import { AuxiliumComponent } from "../auxilium-component";

export class MenuDivider extends AuxiliumComponent {
	parsedCallback() {
		this.appendChild(document.createElement("hr"));
	}
}